import { render, staticRenderFns } from "./CustomerHubMemberships.vue?vue&type=template&id=4f56a152&scoped=true"
import script from "./CustomerHubMemberships.vue?vue&type=script&lang=js"
export * from "./CustomerHubMemberships.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubMemberships.vue?vue&type=style&index=0&id=4f56a152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56a152",
  null
  
)

export default component.exports